import { CommercialCardOrientation } from '../../../../../../components/commercialCard/types/commercialCardOrientation';
import { commonStyles } from '../commonStyles/common';
import { horizontalCommonStyles } from '../commonStyles/horizontalCommon';
import { verticalCommonStyles } from '../commonStyles/verticalCommon';
import { CommercialCardVariant } from '../variants';
export const getNeutralImageStyles = (FOUNDATIONS, FONT) => {
    return {
        [CommercialCardVariant.NEUTRAL_IMAGE]: {
            ...commonStyles(FOUNDATIONS, FONT),
            [CommercialCardOrientation.VERTICAL]: {
                ...verticalCommonStyles(FOUNDATIONS, FONT),
                container: {
                    ...verticalCommonStyles(FOUNDATIONS, FONT).container,
                    background_color: FOUNDATIONS.color_neutral_bg_static_100,
                },
                contentContainer: {
                    ...verticalCommonStyles(FOUNDATIONS, FONT).contentContainer,
                    background_color: FOUNDATIONS.color_neutral_bg_static_100,
                },
            },
            [CommercialCardOrientation.HORIZONTAL]: {
                ...horizontalCommonStyles(FOUNDATIONS, FONT),
                container: {
                    ...horizontalCommonStyles(FOUNDATIONS, FONT).container,
                    background_color: FOUNDATIONS.color_neutral_bg_static_100,
                },
                contentContainer: {
                    ...horizontalCommonStyles(FOUNDATIONS, FONT).contentContainer,
                    background_color: FOUNDATIONS.color_neutral_bg_static_100,
                },
            },
        },
    };
};
//# sourceMappingURL=neutralImage.js.map